/**
 * useSettingsEntry — what the user menu's **Settings** item opens for this
 * viewer, or null to hide it: the account in scope when they may read
 * accounts, else the location in scope when they may read locations. The
 * checks are the Executive dashboard's (usePermissions canRead for 'accounts'
 * and 'locations').
 */
import { usePermissions } from '@turn-connect/hooks';
import { settingsEntryTarget, type SettingsTarget } from '../utils/settingsDialogs';

export function useSettingsEntry(
  user: Record<string, unknown> | null | undefined,
  permissions: string[],
  scope: { accountId?: string | null; locationId?: string | null }
): SettingsTarget | null {
  const { canRead: canReadAccount } = usePermissions(user, permissions, 'accounts');
  const { canRead: canReadLocation } = usePermissions(user, permissions, 'locations');
  return settingsEntryTarget({ canReadAccount, canReadLocation, accountId: scope.accountId, locationId: scope.locationId });
}
